import ApiUrl from "../../../../configTools/api";
import { apiGetList } from "../../../../configTools/apiGet";
const User = JSON.parse(localStorage.getItem("user-info"));

const Get = (setValues, setPages, page = 1, limit = 20, search = '') => {
    const qParam = search ? `&q=${encodeURIComponent(search)}` : '';
    // apiGetList always hands back an array, so the spread below can no longer throw - the
    // previous [...data.response] crashed outright on any non-2xx JSON body.
    return apiGetList(ApiUrl.LabAdmin_Orders + `?page=${page}&limit=${limit}${qParam}`, (list, body)=>{
        setValues([...list].sort((a, b) => b.id - a.id));
        if (setPages) setPages({ total: body.total || 0, pages: body.pages || 1, page: body.page || 1 });
    });
}

const GetByStatus = (status, setValues, setPages, page = 1, limit = 20, search = '') => {
    const qParam = search ? `&q=${encodeURIComponent(search)}` : '';
    // apiGetList always hands back an array, so the spread below can no longer throw - the
    // previous [...data.response] crashed outright on any non-2xx JSON body.
    return apiGetList(ApiUrl.LabAdmin_Orders+"/bystatus/"+status+`?page=${page}&limit=${limit}${qParam}`, (list, body)=>{
        setValues([...list].sort((a, b) => b.id - a.id));
        if (setPages) setPages({ total: body.total || 0, pages: body.pages || 1, page: body.page || 1 });
    });
}

const UpdateStatus = (id,body,setValues,toast,toastid,reset) => {
    fetch(ApiUrl.LabAdmin_Orders+"/orderstatus/"+id,{
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer '+User.token
        },
        body: JSON.stringify(body)
    })
    .then(res=>res.json())
    .then(data =>{
        if(data.success){
            setTimeout(() => {
              toast.update(toastid, { render: "Updated", type: "success", isLoading: false, autoClose:2000, position: toast.POSITION.BOTTOM_CENTER });
            }, 500);
            Get(setValues);
            reset();
        }
        else{
            setTimeout(() => {
              toast.update(toastid, { render: data.response, type: "error", isLoading: false, autoClose:2000, position: toast.POSITION.BOTTOM_CENTER });
            }, 500);
        }
    });
}

const UpdateDepartment = (id,body,setValues,toast,toastid,reset) => {
    fetch(ApiUrl.LabAdmin_Orders+"/orderdepartment/"+id,{
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer '+User.token
        },
        body: JSON.stringify(body)
    })
    .then(res=>res.json())
    .then(data =>{
        if(data.success){
            setTimeout(() => {
              toast.update(toastid, { render: "Updated", type: "success", isLoading: false, autoClose:2000, position: toast.POSITION.BOTTOM_CENTER });
            }, 500);
            Get(setValues);
            reset();
        }
        else{
            setTimeout(() => {
              toast.update(toastid, { render: data.response, type: "error", isLoading: false, autoClose:2000, position: toast.POSITION.BOTTOM_CENTER });
            }, 500);
        }
    });
}

const Delete = (id,setValues,toast,toastid) => {
    fetch(ApiUrl.LabAdmin_Orders+"/"+id,{
        method: 'DELETE',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer '+User.token
        }
    })
    .then(res=>res.json())
    .then(data =>{
        if(data.success){
            setValues(prev => prev.filter(item => item.id !== id));
            setTimeout(() => {
              toast.update(toastid, { render: "Order deleted", type: "success", isLoading: false, autoClose:2000, position: toast.POSITION.BOTTOM_CENTER });
            }, 500);
        }
        else{
            setTimeout(() => {
              toast.update(toastid, { render: data.response || "Delete failed", type: "error", isLoading: false, autoClose:2000, position: toast.POSITION.BOTTOM_CENTER });
            }, 500);
        }
    });
}

const Functions = {Get,GetByStatus,UpdateDepartment,UpdateStatus,Delete};
export default Functions;
